import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  FormFeedback,
} from "reactstrap";
import { DragDropZoneFile } from "@ui-partents/Form/FormUpload";
import { useDispatch } from "react-redux";
import JoditEditor from "jodit-react";
import { atcCreateReference } from "@actions";
import * as Config from "@constants/Config";
import * as Yup from "yup";
import { Formik } from "formik"; // Remove 'Field' import

const ModalAddReferences = ({ isOpen, toggle, type, dataCurrent }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [isType, setType] = useState("html");

  useEffect(() => {
    if (type === 'edit' && dataCurrent) {
      setType(dataCurrent.Type || "html");
    }
  }, [dataCurrent, type]);

  // Validation Schema with Yup
  const validationSchema = Yup.object({
    Name: Yup.string().required("This is required."),
    avomdUrl: isType === "avomd" ? Yup.string().url("Invalid URL format").required("AvoMD URL is required.") : Yup.string(),
    Content: isType === "html" ? Yup.string().required("Content is required.") : Yup.string(),
    File: isType === "pdf" ? Yup.mixed().required("File is required.") : null
  });

  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append("Action", type === 'add' ? "Create" : "Update");
    formData.append("Type", isType);
    formData.append("Target", "Reference");
    formData.append("Name", values.Name);

    if (isType === "pdf" && values.File) {
      formData.append("File", values.File[0]);
    }

    if (isType === "html" && values.Content) {
      formData.append("Contents", values.Content);
    }

    if (isType === "avomd" && values.avomdUrl) {
      formData.append("Contents", values.avomdUrl);
    }

    dispatch(atcCreateReference(formData, id));
    toggle();
  };

  console.log(dataCurrent, "dataCurrent");
  return (
    <Modal style={{ maxWidth: "900px" }} isOpen={isOpen} backdrop="static" className="modal-dialog-centered">
      <ModalHeader toggle={toggle}>
        <span className="--text-primary">{type === 'add' ? "Add Reference" : "Edit Reference"}</span>
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={{
            Name: dataCurrent?.ReferenceName || "",
            avomdUrl: dataCurrent?.AvoMDUrl || "",
            Content: dataCurrent?.Contents || "",
            File: dataCurrent?.File || null,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange, handleBlur, handleSubmit, errors, touched, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col sm={8}>
                  <FormGroup>
                    <Label for="Name">Name</Label>
                    <Input
                      type="text"
                      name="Name"
                      value={values.Name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={touched.Name && !!errors.Name}
                    />
                    {touched.Name && errors.Name && <FormFeedback>{errors.Name}</FormFeedback>}
                  </FormGroup>
                </Col>
                {(type === 'add' || type === 'edit') && (
                  <Col sm={12}>
                    <FormGroup tag="fieldset">
                      {["html", "pdf", "avomd"].map((item) => (
                        <FormGroup check key={item}>
                          <Label check>
                            <Input
                              type="radio"
                              name="type"
                              onChange={() => {
                                setType(item);
                                setFieldValue("Content", ""); // Clear content when type changes
                              }}
                              checked={isType === item}
                            />
                            {item === 'html' && "HTML Contents"}
                            {item === 'pdf' && "PDF File"}
                            {item === 'avomd' && "AvoMD"}
                          </Label>
                        </FormGroup>
                      ))}
                    </FormGroup>
                    {isType === "html" && (
                      <Col sm={12}>
                        <JoditEditor
                          value={values.Content}
                          config={Config.CONFIG_JODIT}
                          onBlur={(newContent) => setFieldValue("Content", newContent)}
                        />
                        {touched.Content && errors.Content && <FormFeedback>{errors.Content}</FormFeedback>}
                      </Col>
                    )}
                    {isType === "pdf" && (
                      <Col sm={12}>
                        <DragDropZoneFile
                          acceptFile="application/pdf"
                          onChange={(files) => setFieldValue("File", files)}
                        />
                        {touched.File && errors.File && <FormFeedback>{errors.File}</FormFeedback>}
                      </Col>
                    )}
                    {isType === "avomd" && (
                      <Col sm={8}>
                        <FormGroup>
                          <Label for="avomdUrl">AvoMD Module URL</Label>
                          <Input
                            type="url"
                            name="avomdUrl"
                            value={values.avomdUrl}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            invalid={touched.avomdUrl && !!errors.avomdUrl}
                          />
                          {touched.avomdUrl && errors.avomdUrl && <FormFeedback>{errors.avomdUrl}</FormFeedback>}
                        </FormGroup>
                      </Col>
                    )}
                  </Col>
                )}
              </Row>
              <ModalFooter className="mt-4">
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                <Button color="primary" type="submit">
                  {type === 'add' ? "Add" : "Update"}
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default ModalAddReferences;